module.exports = __webpack_public_path__ + "static/media/runonpremise.d3849e38.svg";